// extracted by mini-css-extract-plugin
export default {"menu_wrapper":"board-menu-options_menu_wrapper__txQw6","menu_head":"board-menu-options_menu_head__AO7gr","menu_list_item":"board-menu-options_menu_list_item__qqWHZ"};